import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AccessQuote.css';

export default function AccessQuote() {
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = e => {
    e.preventDefault();
    const key = code.trim().toLowerCase();
    if (['gurapalab', 'connara'].includes(key)) {
      navigate(`/b2b/quote/${key}`);
    } else {
      setError('Invalid access code. Please try again.');
    }
  };

  return (
    <div className="access-quote-container">
      <h1>Access Your Quote</h1>
      <form onSubmit={handleSubmit} className="access-quote-form">
        <input
          type="password"
          placeholder="Enter your access code"
          value={code}
          onChange={e => { setCode(e.target.value); setError(''); }}
          required
        />
        <button type="submit">Submit</button>
      </form>
      {error && <p className="error-message">{error}</p>}
      <p className="help-text">
        Need help? Contact <a href="mailto:b2b@yourcompany.com">cto.jo@arcanes.ai</a>
      </p>
    </div>
  );
}